import NiceModal from '@ebay/nice-modal-react'
import { UserProfileModel } from 'mvppoker-portal-common/api'
import React, { useEffect } from 'react'
import { useActiveUser } from '../../../../state/hooks/ActiveUserHooks'
import { useChats, useUnreadChats } from '../../../../state/hooks/ProfileDataHooks'
import { createMVPModal } from '../../Modal'
import { FriendsChatModalView } from './FriendsChatModalView'
import { friendsService } from '../../../../logic/FriendsService'

class FriendsChatModal
{
	Show(friend: UserProfileModel) 
	{
		NiceModal.show(createMVPModal('friends-chat-modal', () =>
		{
			const user = useActiveUser()!
			const { chats } = useChats()
			const { setReadChat } = useUnreadChats()

			const chat = chats[friend.userId] ?? []

			useEffect(() => {
				setReadChat(friend.userId)
			}, [chat])


			const clickSendMessage = (message: string) => {
				if (message.length > 0){
					friendsService.sendFriendsChat(message, friend.userId)
				}
			}

			return <FriendsChatModalView 
				userId={user.user.id}
				userAvatar={user.user.info.avatar}
				chat={chat}
				friend={friend}
	
				clickSendMessage={clickSendMessage}
			/>
		}))
	}
}

const modal = new FriendsChatModal()
export default modal
